export const FEED_TYPES = ['bottle', 'breast_left', 'breast_right', 'solid'] as const;
export type FeedType = (typeof FEED_TYPES)[number];

export const SLEEP_LOCATIONS = ['cot', 'bed', 'stroller', 'car', 'carrier', 'other'] as const;
export type SleepLocation = (typeof SLEEP_LOCATIONS)[number];

export const PUMP_SIDES = ['left', 'right', 'both'] as const;
export type PumpSide = (typeof PUMP_SIDES)[number];

export const DIAPER_KINDS = ['pee', 'poop', 'both'] as const;
export type DiaperKind = (typeof DIAPER_KINDS)[number];

export const DIAPER_CONSISTENCIES = ['liquid', 'soft', 'formed', 'hard'] as const;
export type DiaperConsistency = (typeof DIAPER_CONSISTENCIES)[number];

export const DIAPER_COLORS = ['yellow', 'green', 'brown', 'black', 'red', 'other'] as const;
export type DiaperColor = (typeof DIAPER_COLORS)[number];

export const BOTTLE_CONTENTS = ['formula', 'expressed', 'mix'] as const;
export type BottleContent = (typeof BOTTLE_CONTENTS)[number];

export const DEFAULTS = {
  sleepMaxMinutes: 180,
  feedMaxMinutes: 60,
  pumpMaxMinutes: 45,
  sleepAutoEndMinutes: 360,
  feedAutoEndMinutes: 120,
  pumpAutoEndMinutes: 120,
} as const;

export const MEASUREMENT_KINDS = ['weight', 'length', 'head_circumference', 'temperature'] as const;
export type MeasurementKind = (typeof MEASUREMENT_KINDS)[number];

/** Body temperatures at or above this (°C) get a warning treatment. */
export const FEVER_THRESHOLD_C = 38;

// Quick-log tile ids. The first 8 ship enabled by default; the trailing
// 'measurement', 'milestone', 'medication' and 'temperature' tiles are in
// the catalogue but hidden until the user enables them in Settings.
export const TILE_IDS = [
  'sleep',
  'bottle',
  'bL',
  'bR',
  'breast',
  'pump',
  'solid',
  'diaper',
  'measurement',
  'milestone',
  'medication',
  'temperature',
] as const;
export type TileId = (typeof TILE_IDS)[number];
